import {
  BrowseDataJsonLd,
  BrowsePageMeta,
  BrowsePageStream,
  ProductMiniAdpWithBasketFlyout,
  SizeSelectionOpenedStateKey,
  SpotlightSlider,
  useDeepLinkOpener,
  useMiniAdpDialogOpenedState,
} from '@aboutyou/logic-components';
import {
  extraLargeScreensLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {ResetGenderOnHistoryBack} from './ResetGenderOnHistoryBack';

export const HomePage = () => {
  const {open: openProductMiniADPDialog} = useMiniAdpDialogOpenedState();

  useDeepLinkOpener();

  return (
    <Wrapper>
      <ResetGenderOnHistoryBack />
      <BrowsePageMeta />
      <BrowseDataJsonLd />
      <BrowsePageStream
        SliderComponent={SpotlightSlider}
        onAddToBasketCtaClick={openProductMiniADPDialog}
      />
      <ProductMiniAdpWithBasketFlyout
        renderInPortal
        showAddToWishlistButton
        sizeSelectionStateManagerKey={
          SizeSelectionOpenedStateKey.BASKET_FLYOUT_SIZE_SELECTION
        }
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    --gap: 48px;
    ${tabletAndUpLinaria('--gap: 64px;')}
    ${extraLargeScreensLinaria('--gap: 80px;')}

    margin-bottom: var(--gap);
  }
`;
